import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiLinkedin } from "react-icons/si";
import { FiInstagram } from "react-icons/fi";
import { RxArrowTopRight } from "react-icons/rx";
import { Button, GhostButton } from "../Button/Button";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/logo.webp";
import connect from "../../Assets/connect.webp";
import { LiaChessSolid } from "react-icons/lia";
import { BsJournalCode } from "react-icons/bs";
import { IoStorefrontOutline } from "react-icons/io5";
import { LiaPeopleCarrySolid } from "react-icons/lia";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { BsHddNetwork } from "react-icons/bs";

export const Header = (prop) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [openNav, setOpenNav] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openDrop, setOpenDrop] = useState(false);
  useEffect(() => {
    // Function to handle scroll event
    const handleScroll = () => {
      // Check if the page is scrolled
      if (window.scrollY > 0) {
        setIsScrolled(true); // Set state to indicate scrolling
      } else {
        setIsScrolled(false); // Set state to indicate no scrolling
      }
    };

    // Add event listener for scroll
    window.addEventListener("scroll", handleScroll);

    // Clean up function to remove event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Run effect only once on component mount

  return (
    <>
      <div className={`sticky-pos-header ${isScrolled ? "add-shadow" : ""}`}>
        {/* <div className='top-info-bar container-style'>
        <div className='content-sizing top-info-bar-wrapper'>
          <ul className='sides-top-info-bar social-media-list'>
              <li><a href="https://www.facebook.com/people/DataDept/61557241845977/" target='_blank' aria-label="Visit Our Facebook"><FaFacebookF /></a></li>
              <li><a href="https://twitter.com/DataDeptX" target='_blank' aria-label="Visit Our Twitter"><FaXTwitter/></a></li>
              <li><a href="https://www.linkedin.com/company/DataDept/about/" target='_blank' aria-label="Visit Our Linkedin"><SiLinkedin/></a></li>
              <li><a href='https://www.instagram.com/DataDept_solutions/?hl=en' target='_blank' aria-label="Visit Our Instagram"><FiInstagram /></a></li>
          </ul>

          <aside className='sides-top-info-bar contact-top-header-info'>
            <p>Level up your business with <Link to="/about-us">DataDept</Link></p>
          </aside>
        </div>
      </div> */}

        <header className="container-style">
          <div className="content-sizing header">
            <div className="logo-and-nav">
              <div className="logo">
                <Link to="/">
                  <img src={logo} alt="logo" />
                </Link>
              </div>
              <nav>
                <ul>
                  <li
                    className={
                      prop.selectedPage === "/" ? "active-menu-itm" : ""
                    }
                  >
                    <Link to="/">Home</Link>
                  </li>
                  <li
                    className={
                      prop.selectedPage === "about" ? "active-menu-itm" : ""
                    }
                  >
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li
                    className={
                      prop.selectedPage === "service"
                        ? "service-button active-menu-itm"
                        : "service-button"
                    }
                    onMouseEnter={() => setOpenDrop(true)}
                    onMouseLeave={() => setOpenDrop(false)}
                  >
                    <Link
                      to="/services/general"
                      onClick={() => setOpenDrop(false)}
                    >
                      Services <i className="bi bi-caret-down-fill"></i>
                    </Link>
                    <div
                      className={
                        openDrop
                          ? "service-drop-down open-box-drop"
                          : "service-drop-down"
                      }
                    >
                      <div className="box-service-container container-style">
                        <div className="content-sizing services-list">
                          <ul>
                            <li
                              onClick={() => {
                                navigate("/services/development");
                                setOpenDrop(false);
                              }}
                            >
                              <span>
                                <AiOutlineAppstoreAdd />
                              </span>
                              <div>
                                <h4>Software Applications</h4>
                                <p>
                                  Making tailored software solutions for your
                                  business
                                </p>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                navigate("/services/crm");
                                setOpenDrop(false);
                              }}
                            >
                              <span>
                                <LiaPeopleCarrySolid />
                              </span>
                              <div>
                                <h4>CRM Solutions</h4>
                                <p>
                                  Efficient customer relationship management.
                                </p>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                navigate("/services/web");
                                setOpenDrop(false);
                              }}
                            >
                              <span>
                                <BsJournalCode />
                              </span>
                              <div>
                                <h4>Web Applications</h4>
                                <p>Dynamic solutions for web-based needs.</p>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                navigate("/services/e-commerces");
                                setOpenDrop(false);
                              }}
                            >
                              <span>
                                <IoStorefrontOutline />
                              </span>
                              <div>
                                <h4>E-Commerce</h4>
                                <p>Tailored solutions for online success.</p>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                navigate("/services/management");
                                setOpenDrop(false);
                              }}
                            >
                              <span>
                                <LiaChessSolid />
                              </span>
                              <div>
                                <h4>Management</h4>
                                <p>Dynamic solutions for web-based needs.</p>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                navigate("/services/it");
                                setOpenDrop(false);
                              }}
                            >
                              <span>
                                <BsHddNetwork />
                              </span>
                              <div>
                                <h4>IT Support</h4>
                                <p>Reliable support for your technology.</p>
                              </div>
                            </li>
                          </ul>

                          <div>
                            <img
                              src={connect}
                              alt="build connecting"
                              loading="lazy"
                            />
                            <h4>Let's connect and level up</h4>
                            <p>
                              Download slack in your mobile for your daily
                              usage.
                            </p>
                            <Button onClick={() => prop.setIsOpen(true)}>
                              Connect
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className={
                      prop.selectedPage === "faq" ? "active-menu-itm" : ""
                    }
                  >
                    <Link to="/faq">FAQ</Link>
                  </li>
                </ul>
              </nav>
            </div>

            <aside className="contact-with-action">
              <div>
                <h4>
                  Call Us <RxArrowTopRight />
                </h4>
                <p>+1 204-333-4080</p>
              </div>
              <Button onClick={() => navigate("/contact-us")}>
                <p>Contact Us</p>
              </Button>
              <button
                className="responsive-nav-button"
                onClick={() => setOpenNav(true)}
              >
                <i className="bi bi-list"></i>
              </button>
            </aside>
          </div>
        </header>
      </div>

      <div
        className={
          openNav
            ? "responsive-nav-bar-container open-res-nav"
            : "responsive-nav-bar-container close-res-nav"
        }
      >
        <GhostButton onClick={() => setOpenNav(false)}>
          Close <i className="bi bi-x-lg"></i>
        </GhostButton>
        <ul>
          <li>
            <Link to="/" onClick={() => setOpenNav(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about-us" onClick={() => setOpenNav(false)}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/services/general" onClick={() => setOpenNav(false)}>
              Services
            </Link>
          </li>
          <li>
            <Link to="/faq" onClick={() => setOpenNav(false)}>
              FAQ
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};
